import validate from "/usr/src/app/content/n3-spas-a29bb16b-34c5-4a11-8963-df78fc8159d5/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-a29bb16b-34c5-4a11-8963-df78fc8159d5/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}